import React from 'react';

import { SvgIcon } from '@mui/material';

import { IconColors } from './icon-utils';

export function ExpandedList5Icon(): JSX.Element {
  return (
    <SvgIcon style={{ height: 90, width: 62 }} viewBox="0 0 61 82">
      <g fill="none" fillRule="evenodd">
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(-1 -5)"
        >
          <tspan x="0" y="13">
            I.
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(-1 -5)"
        >
          <tspan x="0" y="85">
            II.
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(-1 -5)"
        >
          <tspan x="11" y="30">
            A.
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(-1 -5)"
        >
          <tspan x="11" y="48">
            B.
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(-1 -5)"
        >
          <tspan x="22" y="66">
            1.
          </tspan>
        </text>
        <path
          d="M11 8H62V10H11zM15 80H62V82H15zM27 25H62V27H27zM27 43H62V45H27zM37 61H62V63H37z"
          fill={IconColors.Grey}
          transform="translate(-1 -5)"
        />
      </g>
    </SvgIcon>
  );
}
